import { title } from '../../../../corpEnvironment.ts'


const issuerMessageModule = {
    namespaced: true,
    state: {
        status: null,
        id: null,
        pagination: null,
        list: [],
        isLoading: false
    },
    actions: {
        getStatus({ dispatch, commit }, ogrn) {

            return dispatch('v3/API', {
                method: 'issuer_event',
                data: {
                    action: 'status', 
                    ogrn
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.shortResume.issuer.status', value: e.data?.data?.status }, { root: true })
                    commit('setStateObject', { name: 'card.shortResume.issuer.id', value: e.data?.data?.id }, { root: true })
                }
            }).catch(err => { console.error(err.message) })
        },
        getData({ dispatch, commit, state }, { ogrn, limit, offset }) {
            commit('setStateObject', { name: 'card.shortResume.issuer.isLoading', value: true }, { root: true })

            return dispatch('v3/API', {
                method: 'issuer_event',
                data: {
                    ogrn,
                    action: 'list_event',
                    limit: limit || 25,
                    offset: offset || 0
                }
            }, { root: true }).then(e => {
                if(e.status === 200 && e.data?.code === 0) {
                    commit('setStateObject', { name: 'card.shortResume.issuer.list', value: e.data?.data?.list_events }, { root: true })
                    commit('setStateObject', { name: 'card.shortResume.issuer.pagination', value: e.data?.data?.pagination }, { root: true })
                } else {
                    dispatch('showErrorPopUp', `При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки ${title}.`, { root: true })
                }
                commit('setStateObject', { name: 'card.shortResume.issuer.isLoading', value: false }, { root: true })
            }).catch(err => {
                commit('setStateObject', { name: 'card.shortResume.issuer.isLoading', value: false }, { root: true })
                dispatch('showErrorPopUp', `При загрузке данных произошла ошибка. Повторите ваш запрос позднее или обратитесь в службу технической поддержки ${title}.`, { root: true })
                console.error(err.message)
            })
        }
    },
    getters: {
        link(state) {
            if(state.id) {
                return `https://www.e-disclosure.ru/portal/company.aspx?id=${state.id}`
            } else {
                return ''
            }
        }
    }
}

export default issuerMessageModule